import React from 'react'
import OverviewCard from '../../common/OverviewCard'
import BarChart from '../../common/BarChart'
import { getDateRangeLabel } from '../../../../common/DateRange/dateRangeOptions'

// Single-series bar chart of order value (USD) per month.
const OrderValueByMonth = ({ orderValues, dateRange }) => {
    const rows = orderValues ?? []

    const labels = rows.map((r) => r.monthYear)
    const datasets = [
        {
            label: 'Order value',
            color: '#3a3e48',
            data: rows.map((r) => r.orderValue)
        }
    ]

    return (
        <OverviewCard
            title='Order value by month'
            subtitle={`${getDateRangeLabel(dateRange)} · USD`}
            className='h-full'
        >
            <BarChart labels={labels} datasets={datasets} />
        </OverviewCard>
    )
}

export default OrderValueByMonth
